import Vue from 'vue';
import App from './App.vue';
import axios from 'axios';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from '@/router'

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts;

Vue.use(ElementUI)

Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
axios.defaults.baseURL = 'https://member.management.biggerlens.cn:8081'


new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
